import { ExerciseCompareBase } from './exerciseCompareBase';

export class ExerciseCompare extends ExerciseCompareBase {
  constructor() {
    super('ExerciseCompare', (gen, genData) => ({
      a: gen.generate(genData),
      b: gen.generate(genData),
    }));
  }
}
